import React from 'react'
import {IExpenseFilterModel} from '../CarModel'
import DataTable, {TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IExpenseFilterModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  onPageSizeChange?: (size: number) => void
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (branch: IExpenseFilterModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (branch: IExpenseFilterModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const ExpenseLogTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const branchColumns: TableColumn<IExpenseFilterModel>[] = [
    {key: 'plate', label: 'Plaka', className: 'fw-semibold', sortable: true},
    {key: 'expenseName', label: 'Gider Adı', sortable: true},
    {key: 'period', label: 'Dönem', sortable: true},
    {key: 'date', label: 'Tarih', sortable: true},
    {key: 'amount', label: 'Tutar', sortable: true},
    {key: 'paymentDate', label: 'Ödeme Tarihi', sortable: true},
    {key: 'payment', label: 'Ödeme'},
    {key: 'processingCompany', label: 'İşlem Firma'},
  ]

  return (
    <DataTable
      data={data}
      columns={branchColumns}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Kayıt bulunamadı'
    />
  )
}
